module.exports = __webpack_public_path__ + "img/vip2.9c9af2c0.png";